
import { toast } from "sonner";
import { ModalCampaignQuestionFormData } from "@/types/modalCampaigns";
import { CampaignFormValues } from "../types/formTypes";

export const validateFormSubmission = (
  values: CampaignFormValues, 
  questions: ModalCampaignQuestionFormData[]
): boolean => {
  // Validate quiz settings if quiz is enabled
  if (values.has_quiz) {
    if (questions.length === 0) {
      toast.error('Je moet ten minste één vraag toevoegen voor een quiz');
      return false;
    }

    // Validate quiz questions
    for (const q of questions) {
      if (!q.question_text.trim()) {
        toast.error('Alle vragen moeten tekst bevatten');
        return false;
      }
      
      if (q.options.length < 2) {
        toast.error('Elke vraag moet ten minste 2 opties hebben');
        return false;
      }
      
      if (q.options.some(opt => !opt.trim())) {
        toast.error('Alle opties moeten tekst bevatten');
        return false;
      }
      
      if (q.correct_options.length === 0) {
        toast.error('Elke vraag moet ten minste 1 juist antwoord hebben');
        return false;
      }
    }
  }

  // Validate dates
  if (values.start_date > values.end_date) {
    toast.error('De startdatum moet voor de einddatum liggen');
    return false;
  }

  return true;
};
